import { Grid } from 'react-feather';
import { Link } from 'react-router-dom';
import logo from '@/assets/images/logo/logo.png';
import logoDark from '@/assets/images/logo/logo_dark.png';
import { useTheme } from '../ThemeContext';

/** CUBA SidebarLogo — full logo + collapse toggle */
export function SidebarLogo() {
  const { toggleIcon, toggleSidebar, mixLayout } = useTheme();

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  return (
    <div className="logo-wrapper">
      <Link to="/">
        <img
          className="img-fluid d-inline"
          src={mixLayout === 'dark-only' ? logoDark : logo}
          alt="TLN Connect"
        />
      </Link>
      <div className="back-btn" onClick={openCloseSidebar} role="button" tabIndex={0}>
        <i className="fa fa-angle-left" />
      </div>
      <div className="toggle-sidebar" onClick={openCloseSidebar} role="button" tabIndex={0}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
    </div>
  );
}
